var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav"},_vm._l((_vm.navItems),function(item){return _c('li',{key:item['.name'],staticClass:"nav-item"},[_c('router-link',{class:['nav-link'],attrs:{"to":{ name: item.name }}},[_vm._v(_vm._s(item.label))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }